module.exports = __webpack_public_path__ + "img/硫磺温泉毛孔净化套.9f7562e4.jpg";